import {
  Workflow,
  WorkflowExecutionState,
  WorkflowFilterResponse
} from '../types'

const buildWorkflowFromFilterResult = (
  filterResult: WorkflowFilterResponse
) => {
  const workflowExecutionState = JSON.parse(
    filterResult.workflow_execution_state
  ) as WorkflowExecutionState

  return {
    uuid: filterResult.uuid,
    status: filterResult.uuid_status,
    workflowmodel_uuid: workflowExecutionState.workflowmodel_uuid,
    workflowmodel_version: workflowExecutionState.workflowmodel_version,
    workflowmodel_instructions_from_version:
      workflowExecutionState.workflowmodel_instructions_from_version,
    state: workflowExecutionState.state
  } as Workflow
}

const WorkflowFactory = { buildWorkflowFromFilterResult }

export default WorkflowFactory
